/**
 * Removes diacritics from a string for search purposes
 * @param str - The string to remove diacritics from
 * @returns String without diacritics
 */
export function removeDiacritics(str: string): string {
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036F]/g, '')
        .toLowerCase()
}
